import { useEffect } from "react";
import { useSelector } from "react-redux";
import { globalsSelector } from "store/globals";
import { isJustmedsTenant, isOpenedInIframe } from "utils/helpers";
import { generateWhiteLabelStyles, loadWhiteLabelFont } from "utils/helpers/white-label";
const useWhiteLabeling = () => {
	const isInIframe = isOpenedInIframe();
	// Get globals from Redux store
	const globals = useSelector(globalsSelector);

	// Extract white labeling configuration
	const isWhiteLabeled = globals?.tenant_info?.tenant_config?.is_white_labeled;
	const customLogo = globals?.tenant_info?.tenant_config?.logo_link;
	const tenantConfig = globals?.tenant_info?.tenant_config;

	// Apply white label styles globally when configuration is available
	useEffect(() => {
		if (isWhiteLabeled && tenantConfig && isInIframe) {
			const styleId = "white-label-styles";

			// Remove existing style if present
			const existingStyle = document.getElementById(styleId);
			if (existingStyle) {
				existingStyle.remove();
			}

			// Load custom font if provided
			if (tenantConfig?.font_family?.name) {
				loadWhiteLabelFont(tenantConfig.font_family.name);
			}

			// Check if current tenant is JustMeds for tenant-specific styles
			const isJustmeds = isJustmedsTenant();

			// Create and inject new style element
			const styleEl = document.createElement("style");
			styleEl.id = styleId;
			styleEl.innerHTML = generateWhiteLabelStyles(tenantConfig, isJustmeds);
			document.head.appendChild(styleEl);

			// Cleanup function to remove styles when component unmounts or dependencies change
			return () => {
				const el = document.getElementById(styleId);
				if (el) el.remove();

				// Cleanup font link if present
				const fontLink = document.getElementById("white-label-font");
				if (fontLink) fontLink.remove();
			};
		}
	}, [isWhiteLabeled, tenantConfig, isInIframe]);

	// Return white labeling configuration for components that need it
	return {
		isWhiteLabeled,
		customLogo,
		tenantConfig,

		// Utility function to check if white labeling is fully configured
		isFullyConfigured: Boolean(isWhiteLabeled && tenantConfig),
	};
};

export default useWhiteLabeling;
